import { parsePhoneNumbers, serializePhoneNumber } from '../../../../utils/phoneNumberUtils';

export const transformValueAddData = (json = {}) => {

  const mappedJson = {
    additionalInfo: Array.isArray(json.additionalInfo) ? json.additionalInfo : [],
    hasChildren: json.haveChildren ? 'YES' : 'NO',
    interests: json.interests ?? [],
    willingToWorkSixDayWeeks: json.openFor6DayWorkWeek === 'Yes' ? 'YES' : 'NO',
    jobTypes: json.jobTypePreference ?? [],
    languageProficiencies: json.languageProficiency?.map((lp) => ({
      language: lp?.language ?? '',
      proficiency: lp?.proficiency || null,
    })) ?? [],
    linkedInUrl: json.linkedInProfile ?? '',
    locationPref1: json.locationPref1 ?? '',
    locationPref2: json.locationPref2 ?? '',
    locationPref3: json.locationPref3 ?? '',
    nativeLocation: json.nativeLocation ?? '',
    noOfChildren: json.noOfChildren ?? 0,
    professionalReferences: json.professionalReference?.map((pr) => ({
      ...pr,
      phoneNumber: pr?.phoneNumber ? serializePhoneNumber(pr.phoneNumber) : '',
    })) ?? [],
    reference1: {
      designation: json.reference1?.designation ?? '',
      name: json.reference1?.name ?? '',
      organisation: json.reference1?.organisation ?? '',
      phoneNumber: json.reference1?.phoneNumber ? serializePhoneNumber(json.reference1.phoneNumber) : '',
      report: Array.isArray(json.reference1?.report) ? json.reference1.report : [],
    },
    reference2: {
      designation: json.reference2?.designation ?? '',
      name: json.reference2?.name ?? '',
      organisation: json.reference2?.organisation ?? '',
      phoneNumber: json.reference2?.phoneNumber ? serializePhoneNumber(json.reference2.phoneNumber) : '',
      report: Array.isArray(json.reference2?.report) ? json.reference2.report : [],
    },
    spouseCurrentOccupation: json.spouseOccupation ?? 'NOT_APPLICABLE',
    willingToRelocate: json.willingToRelocate === 'Yes' ? 'YES' : 'NO',
    willingToTravelToWork: json.willingToTravelForWork === 'Yes' ? 'YES' : 'NO',
  };

  return {
    candidate: {
      valueAdds: mappedJson,
    },
  };
};

export const reverseTransformValueAddData = (valueAdds = {}) => {
  const json = {
    professionalReference: valueAdds.professionalReferences?.map((data) => ({
      ...data,
      phoneNumber: data?.phoneNumber ? parsePhoneNumbers(data.phoneNumber) : {},
    })) ?? [],
    languageProficiency: valueAdds.languageProficiencies ?? [],
    interests: valueAdds.interests ?? [],
    linkedInProfile: valueAdds.linkedInUrl ?? '',
    nativeLocation: valueAdds.nativeLocation ?? '',
    willingToRelocate: valueAdds.willingToRelocate === 'YES' ? 'Yes' : 'No',
    locationPref1: valueAdds.locationPref1 ?? '',
    locationPref2: valueAdds.locationPref2 ?? '',
    locationPref3: valueAdds.locationPref3 ?? '',
    jobTypePreference: valueAdds.jobTypes ?? [],
    willingToTravelForWork: valueAdds.willingToTravelToWork === 'YES' ? 'Yes' : 'No',
    openFor6DayWorkWeek: valueAdds.willingToWorkSixDayWeeks === 'YES' ? 'Yes' : 'No',
    spouseOccupation: valueAdds.spouseCurrentOccupation ?? 'NOT_APPLICABLE',
    haveChildren: valueAdds.hasChildren === 'YES',
    noOfChildren: valueAdds.noOfChildren ?? 0,
    reference1: {
      designation: valueAdds.reference1?.designation ?? '',
      name: valueAdds.reference1?.name ?? '',
      organisation: valueAdds.reference1?.organisation ?? '',
      phoneNumber: valueAdds.reference1?.phoneNumber ? parsePhoneNumbers(valueAdds.reference1.phoneNumber) : {},
      report: Array.isArray(valueAdds.reference1?.report) ? valueAdds.reference1.report : [],
    },
    reference2: {
      designation: valueAdds.reference2?.designation ?? '',
      name: valueAdds.reference2?.name ?? '',
      organisation: valueAdds.reference2?.organisation ?? '',
      phoneNumber: valueAdds.reference2?.phoneNumber ? parsePhoneNumbers(valueAdds.reference2.phoneNumber) : {},
      report: Array.isArray(valueAdds.reference2?.report) ? valueAdds.reference2.report : [],
    },
    additionalInfo: Array.isArray(valueAdds.additionalInfo) ? valueAdds.additionalInfo : [],
  };

  return json;
};

